<template>
    <div class="newspaper-preview">
        <figure class="newspaper-preview__img-wrapper">
            <img
                class="newspaper-preview__img"
                :src="networkImg"
                :alt="material.title"
            />
        </figure>

        <div class="newspaper-preview__content">
            <h3 class="newspaper-preview__title typo typo--name">
                {{ materialTitle }}
            </h3>

            <newspaper-date
                class="newspaper-preview__date"
                :material="material"
            />

            <p class="newspaper-preview__date mb-0">
                Liczba materiałów promocyjnych:
                {{ material.files.length }}
            </p>
        </div>
    </div>
</template>

<script>
import NewspaperDate from './NewspaperDate.vue'

export default {
    name: 'NewspaperPreview',

    components: {
        NewspaperDate
    },

    props: {
        material: {
            type: Object,
            required: true
        }
    },

    computed: {
        materialTitle() {
            const { material } = this
            return `Cykl ${material.series} - ${material.franchise} ${material.format}`
        },
        networkImg() {
            if (this.material.franchise === 'M/SKLEPY') {
                return require('@/assets/img/M_SKLEPY.png')
            } else {
                return require(`@/assets/img/${this.material.franchise}.svg`)
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.newspaper-preview {
    border: 1px solid var(--color-gray-200);
    border-radius: var(--border-radius);
    background-color: var(--color-white);
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    cursor: pointer;

    &__img-wrapper {
        width: 150px;
        min-width: 150px;
        height: 100px;
        overflow: hidden;
        margin-bottom: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &__date {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin: 10px 0;
    }

    + .newspaper-preview {
        margin-top: 20px;
    }

    @include media-breakpoint-down(ms) {
        flex-direction: column;
    }
}
</style>
